import { useEffect, useMemo, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider, Controller  } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../hooks/useAxios";
import axiosInstance from "../../apis/commonAPI";
import { BASE_IMG_URL, SESSION_DATA, user } from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { currentIp } from "../../constants";
import { DomainSubDomain, tpfMember } from "../../data/TableData";
import apiImageInstance from "../../apis/commonApiImg";
import Checkbox from "react-custom-checkbox";
import { MdVerified } from "react-icons/md";
import OtpEnterPopUp from "./OtpEnterPopUp";



const ExpertRegistration = () => {
  const navigate = useNavigate();
  const GET_DOMAIN_URI = "master/getDomainsData";
  const SUBMIT_FORM_DATA_URL = "users/register";
  const Tpf_API_URL = "master/getAllTpfDataList";

  const form = useForm({
    defaultValues: {},
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;

  const [domainData, errorDomain, loadingDomain, axiosFetchDomain] = useAxios();
  const [tpfData, errorTpf, loadingTpf, axiosFetchTpf] = useAxios();
   const [imageLink, errorImageLink, loadingImageLink, axiosFetchImageLink] =
    useAxios();
      const [otpData, errorOtp, loadingOtp, axiosFetchOtp] = useAxios();
  const [submitForm, errorSubmit, loadingSubmit, axiosSubmitUser] = useAxios();


    

    const { id } = useParams();
    const [addUpdate, setAddUpdate] = useState(false);
    const [subDomainFlagData, setSubDomainFlagData] = useState(null);
    const [DomainDataFlag, setDomainDataFlag] = useState([]);
    const [tpfZone, setTpfZone] = useState(false);
    const [tpfMem, setTpfMem] = useState(false);
    const [tpfBranch, setTpfBranch] = useState(false);
    const [tpfBranchList, setTpfBranchList] = useState([]);
    const [tpfOtherBranch, setTpfOtherBranch] = useState(false);
    const [subdomainFlag, setSubdomainFlag] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [otpPhone, setOtpPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [otpFlag, setOtpFlag] = useState(false);
    const [phoneVerifiedFlag, setPhoneVerifiedFlag] = useState(false);
    const [alertFlag, setAlertFlag] = useState(false);

  


  const getDomainData = (url) => {
    axiosFetchDomain({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
 
 

  const GetTpfData = (url) => {
    axiosFetchTpf({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

 

  useEffect(() => {
    GetTpfData(Tpf_API_URL);
  }, [Tpf_API_URL]);

   const GetOtpData = (url) => {
        axiosFetchOtp({
          axiosInstance: axiosInstance,
          url: url,
          method: "GET",
        });
      };

  useEffect(() => {
    getDomainData(GET_DOMAIN_URI);
  }, [GET_DOMAIN_URI]);

  useEffect(() => {
    setDomainDataFlag(domainData);
  }, [domainData]);


  

  const handleTpfZone = (e) => {
    resetField("zone");
    resetField("branch");
    resetField("otherBranch");
   
    if (e.target.value == "y" || e.target.value == "n") {
      if(e.target.value == "y"){
        setTpfMem(true);
      }else{
        setTpfMem(false);
      }
      setTpfZone(true);
      setTpfBranch(false);
      setTpfOtherBranch(false);
    } else {
      setTpfZone(false);
      setTpfBranch(false);
      setTpfOtherBranch(false);
    }
  };
  const handleTpfBranch = (e) => {
    resetField("branch");
    resetField("otherBranch");


    if (e.target.value !== "") {
      tpfData?.[0]?.getAllTpfData?.map((fetchRow, index) => {
        if (e.target.value == fetchRow?._id) {
          setTpfBranchList(fetchRow?.branch);
        }
      });

      setTpfBranch(true);
      setTpfOtherBranch(false);
    } else {
      setTpfBranchList([]);

      setTpfBranch(false);
      setTpfOtherBranch(false);
    }
  };
  const handleTpfOtherBranch = (e) => {
    resetField("otherBranch");
    let branchArr = e.target.value.split("___");
    if (branchArr?.[1] == "Other") {
      setTpfOtherBranch(true);
    } else {
      setTpfOtherBranch(false);
    }
  };

  const handleSubdomain = (e) => {
    resetField("subDomain");
    if (e.target.value !== "") {
      let domainArr = e.target.value.split("___");

      setSubdomainFlag(true);

      DomainDataFlag?.[0]?.DomainsData?.map((fetchRows, index) => {
        if (fetchRows?._id == domainArr?.[0]) {
          setSubDomainFlagData(fetchRows?.subDomains);
        }
      });
    } else {
      setSubDomainFlagData(null);

      setSubdomainFlag(false);
    }
  };
  const handleImageUpload = async (e) => {
      if (e.target.files && e.target.files[0]?.size < 1000000) {
        const acceptedFormats = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "image/gif",
        ];
        const fileExtension = e.target.files[0]?.type;
        if (!acceptedFormats.includes(fileExtension)) {
          resetField("profilePhoto");
          toast.error("Only jpeg, png, jpg, gif image formats are supported", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setImageFile(URL.createObjectURL(e.target.files[0]));
          let fileData = e.target.files[0];
  
          const imageData = {
            imageUpload: fileData,
          };
          await axiosFetchImageLink({
            axiosInstance: apiImageInstance,
            url: "/users/uploadImage",
            method: "POST",
            requestConfig: {
              data: imageData,
            },
          });
        }
      } else {
        resetField("profilePhoto");
        toast.error("Error!! upload Valid image ", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    useEffect(() => {
      setImageFile(imageLink?.[0]);
    }, [loadingImageLink]);

    function isTenDigitPhone(phone) {
      return /^\d{10}$/.test(phone);
    }

  const onFormSubmit = async (data) => {

    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };
    const getDomainArr = data.domain.split("___");
    const getSubDomainArr = data.subDomain.length>0 && data.subDomain.map(item => {
      const [subDomainId, subDomainName] = item.split("___");
      return { subDomainId, subDomainName };
    });

    let formData = {
      email: data.email?data.email:"",
      expertName: toTitleCase(data.expertName),
      password: String(data.confPassword),
      phone: String(`91${data.phone}`),
      usertype: "expert",
      experience: data.experience,
      degree: toTitleCase(data.degree),
      specialization: toTitleCase(data.specialization),
      domain: getDomainArr?.[0],
      domainName: getDomainArr?.[1],
      subDomain: getSubDomainArr,
      profileImagePath: imageFile,
      about: data.about,
      status: "A",
      createdBy: "expert",
      tpfMember: data.tpfmember,
    };
      const getBranchArr = data.branch.split("___");

      formData.zoneId = data.zone;
      formData.branchId = getBranchArr?.[0];
      formData.branchName = getBranchArr?.[1];
      formData.otherBranchName =
        getBranchArr?.[1] == "Other" ? data.otherBranch : "";
       
    
    console.log("formData", formData);
   
    // if(phoneVerifiedFlag){
       await axiosSubmitUser({
          axiosInstance: axiosInstance,
          url: SUBMIT_FORM_DATA_URL,
          method: "POST",
          requestConfig: {
            data: formData,
          },
        });
    
        setAddUpdate(true);
    
    // }else{
    //   toast.error("Please verify your phone number with OTP", {
    //       position: toast.POSITION.TOP_RIGHT,
    //     });
    // }
  };

  useEffect(() => {
    if (errorSubmit) {
      toast.error(`Error!! ${errorSubmit}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (addUpdate) {

      navigate(`/login?userRegister=registered`);
    }
  }, [loadingSubmit, errorSubmit]);


  const toggleDropdown = () => setIsOpen(prev => !prev);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handlePhone = (value) => {
 

    setPhoneVerifiedFlag(false);
    if(value){
      setOtpPhone(value);
    }else{
    setOtpPhone("");
    }
  };
  const handleGetOtp = () => {
    resetField("otp");
    setOtp("");
    if(isTenDigitPhone(otpPhone)){
      GetOtpData(`users/getOtp/${otpPhone}`);
      setOtpFlag(true);
  
    }else{
      toast.error("Please enter a valid 10 digit phone number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  
  }
  
  useEffect(() =>{
  if(otpData?.[0]?.success && otpFlag){
    const newOtp = otpData?.[0].data;
    setAlertFlag(true);
    setOtp(newOtp);
          toast.success(
          otpData?.[0]?.message ,
              {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000
  
              }
          );
  
  }else if(!otpData?.[0]?.success && otpFlag){
        toast.error(
        otpData?.[0]?.message ,
            {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000
  
            }
        );
  
  }
  setOtpFlag(false);
  
  },[otpData]);

  return (
    <>
      <div className="card min-height-100 ">
        <div className="card-title flex-row">
          <h2 className="text-navyBlue">Expert Registration </h2>
          <Link to="/login">
            <button className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />
        <OtpEnterPopUp
                       modalFlag={alertFlag}
                      modalFlagUpdate={setAlertFlag}
                      userOtp={otp}
                      modalPhoneVerifiedFlag={setPhoneVerifiedFlag}
                    
                    />
        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
              <div className="col-md-4  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                Full Name<span className="text-red">*</span>
                </label>
                <input
                  id="expertName"
                  {...register("expertName", {
                    required: {
                      value: true,
                      message: "Full Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Full Name"
                />
                <p className="text-red">{errors.expertName?.message}</p>
              </div>
              
               <div className="col-md-4  tank-col-info">
                              <label htmlFor="phone" className="text-gray text-semi-bold">
                                Contact No.<span className="text-red">*</span>
                              </label>
                              <div className="row">
                              <div className="col-md-9  tank-col-info">
                              <input
                                id="phone"
                                {...register("phone", {
                                  required: {
                                    value: true,
                                    message: "Mobile field should contains atleast 10 digits",
                                  },
                                  pattern: {
                                    value: /^[0-9]/,
                                    message: "Ente Exactly 10 Digits",
                                  },
                                  minLength: { value: 10, message: "Enter 10 digits" },
                                  maxLength: { value: 10, message: "Enter 10 digits" },
                                })}
                                type="text"
                                className="form-control rounded-10 mb-15"
                                placeholder="Enter Mobile"
                                onChange = {(e) => handlePhone(e.target.value)}
                              />
                            
                              <p className="text-red">{errors.phone?.message}</p>
                              </div>
                              
                              <div className="col-md-3  tank-col-info">
                                {
                                  phoneVerifiedFlag ? (
                                    <button type= "button" className="btn btn-sm btn-no-outline-green rounded-10"  style={{ display: "flex", alignItems: "center", gap: "6px" }} title="Phone Verified"
              >                        <MdVerified className="text-green" size={25} /> <span className="">Verified</span>
              
              
                                    </button>
                                  ) : (
                                    <button type= "button" className="btn btn-sm btn-outline-green rounded-10 " onClick={handleGetOtp} title="Click To Get OTP">  Get OTP
                                    </button>
                                  )
                                }
                            
                              </div>
                              </div>
                             
                            </div>

              <div className="col-md-4  tank-col-info">
                <label htmlFor="email" className="text-gray text-semi-bold">
                  Email
                </label>
                <input
                  id="email"
                  {...register("email", {
                    required: {
                      value: false,
                      message: "Email Field is Required",
                    },

                    pattern: {
                      value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                      message: "Enter Valid Email Id",
                    },
                  })}
                  type="email"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Email"
                />
                <p className="text-red">{errors.email?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="newPassword"
                  className="text-gray text-semi-bold"
                >
                  {id ? "New Password" : "Password"}{" "}
                  <span className="text-red">*</span>
                </label>
                <input
                  id="newpassword"
                  {...register("newPassword", {
                    required: {
                      value: id !== undefined ? false : true,
                      message: "New Password Field is Required",
                    },
                  })}
                  type="password"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter New Password"
                />
                <p className="text-red">{errors.newPassword?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="confPassword"
                  className="text-gray text-semi-bold"
                >
                  Confirm Password<span className="text-red">*</span>
                </label>
                <input
                  id="confPassword"
                  {...register("confPassword", {
                    required: {
                      value: id !== undefined ? false : true,
                      message: "Confirm Password Field is Required",
                    },
                    validate: (fieldValue) => {
                      return (
                        fieldValue === watch("newPassword") ||
                        "Your confirm password does no matches with New Password"
                      );
                    },
                  })}
                  type="password"
                  className="form-control rounded-10 mb-15"
                  placeholder="Confirm Password"
                />
                <p className="text-red">{errors.confPassword?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label htmlFor="degree" className="text-gray text-semi-bold">
                  Qualification<span className="text-red">*</span>
                </label>
                {/* <select
                  id="degree"
                  {...register("degree", {
                    required: {
                      value: true,
                      message: "Degree field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Select Degree"
                  onChange={handleSpeclization}
                >
                  <option value="">Select Degree</option>

                  {degreeData?.[0]?.DegreesData?.map((fetchDegree, index) =>
                    fetchDegree?.status == "A" ? (
                      <>
                        <option
                          value={`${fetchDegree?._id}___${fetchDegree?.degreeName}`}
                        >
                          {fetchDegree?.degreeName}
                        </option>
                      </>
                    ) : (
                      <></>
                    )
                  )}
                </select> */}
                 <input
                  id="degree"
                  {...register("degree", {
                    required: {
                      value: true,
                      message: "Qualification Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Qualification "
                />

                <p className="text-red">{errors.degree?.message}</p>
              </div>
              {/* {degreeFlag === true ? ( */}
                <div className="col-md-4  tank-col-info">
                  <label
                    htmlFor="specialization"
                    className="text-gray text-semi-bold"
                  >
                    Specialization<span className="text-red">*</span>
                  </label>
                  <input
                  id="specialization"
                  {...register("specialization", {
                    required: {
                      value: true,
                      message: "Specialization Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Specialization Name"
                />
                 
                  <p className="text-red">{errors.specialization?.message}</p>
                </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="experience"
                  className="text-gray text-semi-bold"
                >
                  Experience (in years)<span className="text-red">*</span>
                </label>
                <input
                  id="experience"
                  {...register("experience", {
                    required: {
                      value: true,
                      message: "Experience Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Experience "
                />
                <p className="text-red">{errors.experience?.message}</p>
              </div>

              <div className="col-md-4  tank-col-info">
                <label htmlFor="domain" className="text-gray text-semi-bold">
                  Domain<span className="text-red">*</span>
                </label>

                <select
                  id="domain"
                  {...register("domain", {
                    required: {
                      value: true,
                      message: "domain Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Select Domain"
                  onChange={handleSubdomain}
                >
                  <option value="">Select Domain</option>

                  {domainData?.[0]?.DomainsData?.map((fetchRow, index) => (
                    <option
                      value={`${fetchRow?._id}___${fetchRow?.domainName}`}
                    >
                      {fetchRow?.domainName}
                    </option>
                  ))}
                </select>

                <p className="text-red">{errors.domain?.message}</p>
              </div>
              {subdomainFlag === true ? (
                <>

<div className="col-md-4 tank-col-info">
      <label htmlFor="subDomain" className="text-gray text-semi-bold">
        Sub-Domain<span className="text-red">*</span>
      </label>

      <Controller
        name="subDomain"
        control={control}
        rules={{
          required: {
            value: true,
            message: "Sub-Domain field is required",
          },
          validate: value =>
            value && value.length > 0
              ? true
              : "Please select at least one sub-domain",
        }}
        render={({ field }) => (
          <div className="custom-dropdown" ref={dropdownRef}>
            <div
              className={`dropdown-header form-control rounded-10 mb-15 ${errors.subDomain ? "border-danger" : ""}`}
              onClick={toggleDropdown}
            >
              {field.value?.length > 0
                ? `${field.value.length} selected`
                : "Select Sub-Domains"}
            </div>

            {isOpen && (
              <div className="dropdown-list">
                {subDomainFlagData?.map((item, index) => {
                  const value = `${item._id}___${item.subDomainName}`;
                  const isChecked = field.value?.includes(value);

                  const handleToggle = () => {
                    const newValue = isChecked
                      ? field.value.filter(v => v !== value)
                      : [...(field.value || []), value];
                    field.onChange(newValue);
                  };

                  return (
                    <div key={index} className="dropdown-option">
                      <Checkbox
                        checked={isChecked}
                        onChange={handleToggle}
                        borderColor="#ccc"
                        size={18}
                        label={item.subDomainName}
                      />
                    </div>
                  );
                })}

              
              </div>
            )}
          </div>
        )}
      />

      <p className="text-red">{errors.subDomain?.message}</p>
    </div>
  

                </>
              ) : (
                ""
              )}

              <div className="col-md-4  tank-col-info">
                <label htmlFor="tpfmember" className="text-gray text-semi-bold">
                  TPF Member<span className="text-red">*</span>
                </label>

                <select
                  id="tpfmember"
                  {...register("tpfmember", {
                    required: {
                      value: true,
                      message: "tpfmember Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  onChange={handleTpfZone}
                >
                  <option value="">Select TPF Membership</option>
                  <option value="y">Yes</option>
                  <option value="n">No</option>
                </select>

                <p className="text-red">{errors.tpfmember?.message}</p>
              </div>
              {(tpfZone === true ) ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label htmlFor="zone" className="text-gray text-semi-bold">
                      {tpfMem==true?"Zone":"Nearest TPF Zone"}<span className="text-red">*</span>
                    </label>

                    <select
                      id="zone"
                      {...register("zone", {
                        required: {
                          value: true,
                          message: "zone Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select zone"
                      onChange={handleTpfBranch}
                    >
                      <option value="">Select zone</option>
                      {tpfData?.[0]?.getAllTpfData?.map((listFetch, index) =>
                        listFetch?.status == "A" ? (
                          <>
                            <option value={`${listFetch?._id}`}>
                              {listFetch?.zone}
                            </option>
                          </>
                        ) : (
                          <></>
                        )
                      )}
                    </select>

                    <p className="text-red">{errors.zone?.message}</p>
                  </div>
                </>
              ) : (
                <>
                
                </>
               
                  
              )}
              
              {tpfBranch === true ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="branch"
                      className="text-gray text-semi-bold"
                    >
                      {tpfMem==true?"Branch":"Nearest TPF Branch"}<span className="text-red">*</span>
                    </label>

                    <select
                      id="branch"
                      {...register("branch", {
                        required: {
                          value: true,
                          message: "Branch Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select Branch"
                      onChange={handleTpfOtherBranch}
                    >
                      <option value="">Select Branch</option>
                      {tpfBranchList?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?._id}___${listFetch?.branchName}`}
                        >
                          {listFetch?.branchName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.branch?.message}</p>
                  </div>
                </>
              ) : (
                ""
              )}
              {tpfOtherBranch === true ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="otherBranch"
                      className="text-gray text-semi-bold"
                    >
                      Other Branch Name<span className="text-red">*</span>
                    </label>
                    <input
                      id="otherBranch"
                      {...register("otherBranch", {
                        required: {
                          value: true,
                          message: "Other Branch Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Enter Other Branch "
                    />
                    <p className="text-red">{errors.otherBranch?.message}</p>
                  </div>
                </>
              ) : (
                ""
              )}

               <div className="col-md-4  tank-col-info">
                             <label htmlFor="profilePhoto" className="text-gray text-semi-bold">
                               Photo<span className="text-red">*</span>
                             </label>
                             <input
                               id="profilePhoto"
                               {...register("profilePhoto", {
                                 required: {
                                   value: true,
                                   message: "Profile Photo Field is Required",
                                 },
                               })}
                               type="file"
                               className="form-control rounded-10 mb-15"
                               onChange={(e) => handleImageUpload(e)}
                               />
                             <p className="text-red">{errors.profilePhoto?.message}</p>
                           </div>
                           
                           {imageFile !=null?<>
                             <div className="col-md-4 tank-col-info">
                           <label htmlFor="profilePhoto" className="text-gray text-semi-bold">
                               Uploaded Image<span className="text-red"></span>
                             </label>
                           <img src={ `${BASE_IMG_URL}${imageFile}`} alt="user image"style={{ minWidth: '20%',maxWidth: '20%' }}/>
                         </div>
                           </>:<></>}
              <div className="col-md-4  tank-col-info">
                <label htmlFor="about" className="text-gray text-semi-bold">
                  About <span className="text-red">*</span>
                </label>
                <textarea
                  id="about"
                  {...register("about", {
                    required: {
                      value: true,
                      message: "About Field is Required",
                    },
                  })}
                  type="textarea"
                  className="form-control rounded-10 mb-15"
                  placeholder="Write something About Your profile"
                  rows={5}
                  cols={40}
                />
                <p className="text-red">{errors.about?.message}</p>
              </div>

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-secondary rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default ExpertRegistration;
